var React = require('react');

function AlignLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"width":"17","height":"3.5","rx":"1.75","key":0}),React.createElement("rect",{"width":"10","height":"3.5","y":"6","rx":"1.75","key":1}),React.createElement("rect",{"width":"13","height":"3.5","y":"12","rx":"1.75","key":2})]));
}

AlignLeft.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16"};

module.exports = AlignLeft;

AlignLeft.default = AlignLeft;
